const moment = require('moment')

export default function getResubmitTime (resubmitDate, timeHours, timeMinutes) {
  const date = moment(resubmitDate).format('DD/MM/YYYY')
  const time = timeHours + ':' + timeMinutes
  const dateTime = moment(date + ' ' + time, 'DD/MM/YYYY HH:mm')
  return dateTime.toDate()
}
